import styled from 'styled-components';
import BannerBG from 'common/src/assets/image/hosting/global_banner.jpg';
import { themeGet } from 'styled-system';

const BannerWrapper = styled.section`
  background-image: url(${BannerBG});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 58vh;
  text-align: center;
  color: #000;
  display: flex;
  align-items: center;

  height: 40vh;
  .particle {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    @media (max-width: 767px) {
      display: none;
    }
  }

  .banner_container {
    color: #000;
    position: relative;
    margin-left: 150px;
    margin-right: 650px;
    margin-top: 0;
    padding: 40px;
  }
  }
  .title {
    font-weight: 600;
    font-size: 42px;
    margin-bottom: 10px;
  }
  .desc{
    font-size: 22px;

  }
  .subtitle {
    margin-top: 40px;
    font-size: 24px;
  }


  @media (min-width: 576px) { 
    height: 45vh;
   }

@media (min-width: 768px) { 
  height: 50vh;
 }

@media (min-width: 992px) { 
  height: 55vh;
 }

@media (min-width: 1200px) { 
  height: 58vh;
 }
`;

export default BannerWrapper;
